/**
 * 企业认证
 */
import store from '@/store'

const HomeAuth = () => import('../../layout/home-auth.vue')
const AuthCompany = () => import('../../views/auth/company-auth/index')
const AuthPerson = () => import('../../views/auth/personal-auth/index')

export default {
  path: '/auth',
  hidden: true,
  meta: { title: '认证信息' },
  component: HomeAuth,
  children: [
    {
      path: '/auth/company',
      meta: { title: '认证信息' },
      component: AuthCompany,
      children: [
        {
          path: '/auth/company/register',
          meta: { title: '注册人信息' },
          component: () => import('../../views/auth/company-auth/auth-register')
        },
        {
          path: '/auth/company/info',
          meta: { title: '企业信息' },
          component: () => import('../../views/auth/company-auth/auth-info')
        },
        {
          path: '/auth/company/shareholder',
          meta: { title: '股东信息' },
          component: () => import('../../views/auth/company-auth/auth-shareholder')
        },
        {
          path: '/auth/company/overview',
          meta: { title: '信息总览' },
          component: () => import('../../views/auth/company-auth/auth-overview')
        },
        {
          path: '/auth/company/businessInfo',
          meta: { title: '业务信息' },
          component: () => import('../../views/auth/company-auth/business-info')
        }
      ]
    },
    {
      path: '/auth/personal',
      redirect: '/auth/personal/register',
      meta: { title: '个人认证' },
      component: AuthPerson,
      children: [
        {
          path: '/auth/personal/register',
          meta: { title: '注册人信息' },
          component: () => import('../../views/auth/personal-auth/auth-register')
        },
        {
          path: '/auth/personal/businessInfo',
          meta: { title: '业务信息' },
          component: () => import('../../views/auth/personal-auth/business-info')
        },
        {
          path: '/auth/personal/overview',
          hidden: true,
          meta: { title: '信息总览' },
          component: () => import('../../views/auth/personal-auth/auth-overview')
        },
      ]
    },
  ]
}
